/**
 * 機能 3: 現在地引き継ぎリンク
 *
 * [data-nearest-shop-link] を持つリンク（店舗一覧ページの「現在地でさがす」等）を
 * クリック → Geolocation API で現在地取得 → href に lat / lng の GET パラメータを
 * 付与して遷移する。
 *
 * 遷移先（来店予約ページ等）では nearest-shop-finder.js が URL パラメータを拾い、
 * 最寄り店舗をエリア・店舗 select に自動反映する。
 */

import { GEOLOCATION_OPTIONS, buildGeolocationErrorMessage } from "./utils.js";

/**
 * 1 つのリンクにクリックハンドラを設定する。
 *
 * @param {HTMLAnchorElement} link - [data-nearest-shop-link] 要素
 * @returns {void}
 */
const setupLink = (link) => {
    link.addEventListener("click", (e) => {
        // 現在地取得後に JS で遷移するため、リンクの即時遷移を止める
        e.preventDefault();

        // 非対応ブラウザのフォールバック
        if (!("geolocation" in navigator)) {
            window.alert("お使いのブラウザは位置情報の取得に対応していません。");
            return;
        }

        // 取得中の二重クリック防止
        link.setAttribute("data-disabled", "");

        navigator.geolocation.getCurrentPosition(
            // 成功: lat / lng を GET パラメータに付与して遷移
            (position) => {
                const url = new URL(link.href, window.location.origin);
                url.searchParams.set("lat", String(position.coords.latitude));
                url.searchParams.set("lng", String(position.coords.longitude));
                window.location.href = url.toString();
            },
            // 失敗（権限拒否 / タイムアウト / 取得不可）
            (error) => {
                link.removeAttribute("data-disabled");
                window.alert(buildGeolocationErrorMessage(error));
            },
            GEOLOCATION_OPTIONS,
        );
    });
};

/**
 * ページ内の全ての [data-nearest-shop-link] を初期化する。
 *
 * @returns {void}
 */
export const setupNearestShopLinks = () => {
    document.querySelectorAll("[data-nearest-shop-link]").forEach(setupLink);
};
